<ng-container *ngIf="isReadOnly; else showInputMultiSelect">
  <div sigvValueDiffItem="contractFormat" class="p-text-bold-500">
    {{
      bindingFormControl?.value
        | multiOptionsMapping : selectOptions
        | replaceNullWith : '-'
    }}
  </div>
</ng-container>
<ng-template #showInputMultiSelect>
  <sigv-form-control-widget
    [fieldName]="fieldName"
    [bindingFormControl]="bindingFormControl"
  >
    <p-multiSelect
      *ngIf="render"
      placeholder=" {{
        (placeholder == undefined ? 'Please Select' : placeholder) | translate
      }}"
      sigvDropdownSetting
      [formControl]="value"
      [options]="selectOptions"
      [panelStyleClass]="useStyle"
      [disabled]="isDisabled"
      appendTo="body"
      class="p-component-fluid"
      (onChange)="onChangeEvent($event)"
    ></p-multiSelect>
  </sigv-form-control-widget>
</ng-template>
